<template>
  <div>
    <slot></slot>
    <span ref="loadMoreEl"></span>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useIntersectionObserver  } from '@vueuse/core'

export default {
  name: 'InfiniteScroll',
  props: {
    disabled: {
      type:Boolean,
      default: false,
    },
  }, 
  setup(props, { emit }) {
    const loadMoreEl = ref()
    const loadCtr = ref(0)
    const isEmitting = ref(false)
    const isEmittingTimeoutInstance = ref()

    const loadMore = () => {
      if (loadCtr.value > 1 && !props.disabled && isEmitting.value === false) {
        isEmitting.value = true
        emit('loadMore')
      }
      loadCtr.value++

      if (isEmittingTimeoutInstance.value) {
        clearTimeout(isEmittingTimeoutInstance.value)
      }

      isEmittingTimeoutInstance.value = setTimeout(() => {
        isEmitting.value = false
      }, 1200)
    }

    useIntersectionObserver(loadMoreEl, () => loadMore(), {
      threshold: 0.5,
    })

    return {
      loadMoreEl,
      loadMore,
    }
  },
}
</script>
